<template>
  <div class="vehicle-brand-manage">
    <el-card>
      <div slot="header" class="clearfix">
        <span>车辆品牌管理</span>
      </div>

      <!-- 搜索区域 -->
      <div class="search-form">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="品牌名称">
            <el-input v-model="searchForm.brandName" placeholder="请输入品牌名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button @click="handleReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 操作按钮 -->
      <div class="toolbar">
        <el-button type="primary" @click="handleAdd">新增品牌</el-button>
        <el-button type="danger" :disabled="multipleSelection.length === 0" @click="handleBatchDelete">批量删除</el-button>
      </div>

      <!-- 数据表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="brandCode" label="品牌编号" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="brandName" label="品牌名称" width="150"></el-table-column>
        <el-table-column label="品牌Logo" width="120">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.logoUrl"
              :src="scope.row.logoUrl"
              fit="contain"
              style="width: 60px; height: 40px; border-radius: 4px;"
              :preview-src-list="[scope.row.logoUrl]"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <span v-else class="no-image">暂无图片</span>
          </template>
        </el-table-column>
        <el-table-column prop="logoUrl" label="Logo地址" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" style="color: #f56c6c;" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.current"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑弹框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      @close="handleDialogClose"
    >
      <el-form
        ref="brandForm"
        :model="brandForm"
        :rules="brandRules"
        label-width="100px"
      >
        <el-form-item label="品牌名称" prop="brandName">
          <el-input v-model="brandForm.brandName" placeholder="请输入品牌名称"></el-input>
        </el-form-item>
        <el-form-item label="品牌Logo" prop="logoUrl">
          <div class="logo-upload-container">
            <div class="logo-upload-area">
              <el-upload
                class="logo-uploader"
                action=""
                :http-request="handleLogoUpload"
                :show-file-list="false"
                :before-upload="beforeLogoUpload"
                accept="image/*"
              >
                <div class="upload-area">
                  <div v-if="!brandForm.logoUrl" class="upload-placeholder">
                    <i class="el-icon-plus"></i>
                    <div class="upload-text">点击上传Logo</div>
                  </div>
                  <img v-else :src="brandForm.logoUrl" class="uploaded-logo" />
                </div>
              </el-upload>
              <div v-if="brandForm.logoUrl" class="logo-actions">
                <el-button size="mini" type="text" @click="previewLogo">预览</el-button>
                <el-button size="mini" type="text" @click="removeLogo">删除</el-button>
              </div>
            </div>
            <div class="upload-tip">
              <span>或手动输入图片地址：</span>
              <el-input v-model="brandForm.logoUrl" placeholder="请输入Logo图片地址" clearable></el-input>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getVehicleBrandPage,
  addVehicleBrand,
  updateVehicleBrand,
  deleteVehicleBrand,
  batchDeleteVehicleBrand
} from '@/api/vehicleBrand'
import { uploadImage } from '@/api/upload'

export default {
  name: 'VehicleBrandManage',
  data() {
    return {
      loading: false,
      tableData: [],
      multipleSelection: [],
      
      // 搜索表单
      searchForm: {
        brandName: ''
      },
      
      // 分页
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      
      // 弹框
      dialogVisible: false,
      dialogTitle: '新增品牌',
      submitLoading: false,
      
      // 表单
      brandForm: {
        id: '',
        brandName: '',
        logoUrl: ''
      },
      
      // 表单验证规则
      brandRules: {
        brandName: [
          { required: true, message: '请输入品牌名称', trigger: 'blur' },
          { min: 1, max: 100, message: '长度在 1 到 100 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  
  computed: {
    isEdit() {
      return !!this.brandForm.id
    }
  },
  
  mounted() {
    this.loadData()
  },
  
  methods: {
    // 加载数据
    async loadData() {
      this.loading = true
      try {
        const params = {
          current: this.pagination.current,
          size: this.pagination.size,
          brandName: this.searchForm.brandName || undefined
        }
        
        const response = await getVehicleBrandPage(params)
        if (response.code === "200") {
          this.tableData = response.data.records || []
          this.pagination.total = response.data.total || 0
        } else {
          this.$message.error(response.message || '加载数据失败')
        }
      } catch (error) {
        console.error('加载数据失败:', error)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    
    // 搜索
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    
    // 重置搜索
    handleReset() {
      this.searchForm = {
        brandName: ''
      }
      this.pagination.current = 1
      this.loadData()
    },
    
    // 新增
    handleAdd() {
      this.dialogTitle = '新增品牌'
      this.brandForm = {
        id: '',
        brandName: '',
        logoUrl: ''
      }
      this.dialogVisible = true
    },
    
    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑品牌'
      this.brandForm = {
        id: row.id,
        brandName: row.brandName,
        logoUrl: row.logoUrl || ''
      }
      this.dialogVisible = true
    },
    
    // 删除
    handleDelete(row) {
      this.$confirm(`确定要删除品牌"${row.brandName}"吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const response = await deleteVehicleBrand(row.id)
          if (response.code === "200") {
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error(response.message || '删除失败')
          }
        } catch (error) {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      })
    },
    
    // 批量删除
    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请选择要删除的品牌')
        return
      }
      
      const brandNames = this.multipleSelection.map(item => item.brandName).join('、')
      this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 个品牌（${brandNames}）吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const ids = this.multipleSelection.map(item => item.id)
          const response = await batchDeleteVehicleBrand(ids)
          if (response.code === "200") {
            this.$message.success('批量删除成功')
            this.loadData()
          } else {
            this.$message.error(response.message || '批量删除失败')
          }
        } catch (error) {
          console.error('批量删除失败:', error)
          this.$message.error('批量删除失败')
        }
      })
    },
    
    // 提交表单
    handleSubmit() {
      this.$refs.brandForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          try {
            let response
            if (this.isEdit) {
              response = await updateVehicleBrand(this.brandForm.id, this.brandForm)
            } else {
              response = await addVehicleBrand(this.brandForm)
            }
            
            if (response.code === "200") {
              this.$message.success(this.isEdit ? '更新成功' : '新增成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message.error(response.message || '操作失败')
            }
          } catch (error) {
            console.error('操作失败:', error)
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    },
    
    // 关闭弹框
    handleDialogClose() {
      this.$refs.brandForm.resetFields()
    },
    
    // 表格选择变化
    handleSelectionChange(selection) {
      this.multipleSelection = selection
    },
    
    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.loadData()
    },
    
    // 当前页变化
    handleCurrentChange(current) {
      this.pagination.current = current
      this.loadData()
    },
    
    // Logo上传处理
    async handleLogoUpload(options) {
      try {
        const response = await uploadImage(options.file)
        if (response && (response.code === 200 || response.code === '200')) {
          this.brandForm.logoUrl = response.data
          this.$message.success('Logo上传成功')
        } else {
          this.$message.error(response?.message || response?.msg || 'Logo上传失败')
        }
      } catch (error) {
        console.error('Logo上传失败:', error)
        this.$message.error('Logo上传失败')
      }
    },
    
    // Logo上传前校验
    beforeLogoUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
      const isLt12M = file.size / 1024 / 1024 < 12
      
      if (!isImage) {
        this.$message.error('Logo只能是 JPG/PNG/GIF 格式!')
        return false
      }
      if (!isLt12M) {
        this.$message.error('Logo大小不能超过 12MB!')
        return false
      }
      return true
    },
    
    // 预览Logo
    previewLogo() {
      if (this.brandForm.logoUrl) {
        const image = new Image()
        image.src = this.brandForm.logoUrl
        const newWindow = window.open()
        newWindow.document.write(`<img src="${this.brandForm.logoUrl}" style="max-width: 100%; max-height: 100%;" />`)
      } else {
        this.$message.warning('请先上传Logo')
      }
    },
    
    // 删除Logo
    removeLogo() {
      this.brandForm.logoUrl = ''
      this.$message.success('Logo已移除')
    },
    
    // 格式化日期时间
    formatDateTime(dateTime) {
      if (!dateTime) return ''
      const date = new Date(dateTime)
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      })
    }
  }
}
</script>

<style scoped>
.vehicle-brand-manage {
  padding: 20px;
}

.search-form {
  margin-bottom: 20px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.toolbar {
  margin-bottom: 20px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}

.logo-upload-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.logo-upload-area {
  position: relative;
  display: inline-block;
}

.logo-uploader {
  width: 120px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
  background-color: #f5f7fa;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-uploader:hover {
  border-color: #409eff;
}

.upload-area {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.upload-placeholder {
  color: #909399;
  font-size: 14px;
  text-align: center;
}

.upload-placeholder i {
  font-size: 24px;
  margin-bottom: 5px;
  display: block;
}

.upload-text {
  font-size: 12px;
}

.uploaded-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.logo-actions {
  position: absolute;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 0 4px 0 4px;
  padding: 2px 5px;
  display: flex;
  gap: 5px;
  z-index: 10;
}

.logo-actions .el-button {
  color: #fff;
  font-size: 12px;
  padding: 0;
}

.upload-tip {
  font-size: 12px;
  color: #999;
}

.upload-tip span {
  margin-bottom: 5px;
  display: block;
}

.no-image {
  color: #999;
  font-size: 12px;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.image-slot i {
  font-size: 20px;
}
</style>
